import {AppointmentIndicatorState} from '../../models/appointment-indicator';
import {Store} from '@ngxs/store';
import {Observable, Subscription} from 'rxjs';
import {StorageService} from '../../services/storage/storage.service';
import {AfterViewInit, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {UtilitiesService} from '../../services/utilities-service/utilities.service';
import {AppTourService} from '../../services/app-tour/app-tour.service';

@Component({
  selector: 'app-date-indicator',
  templateUrl: './date-indicator.component.html',
  styleUrls: ['./date-indicator.component.scss']
})
export class DateIndicatorComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {
  message: string;
  @Input() timeLimit = 0;
  @Input() secondsStart = 0;
  @Input() isFinished: boolean;
  hours = 0;
  minutes = 0;
  seconds = 0;
  tempInterval = null;
  // Output para la vista padre
  @Output() finished = new EventEmitter<number>();
  @Output() isTimeToRemember = new EventEmitter<{ time: { hours: number, minutes: number } }>();

  indicatorIsComplete$: Observable<boolean> = this.store.select<boolean>(AppointmentIndicatorState.getIndicatorIsComplete);
  indicatorSubscription: Subscription;
  constructor(
    private utilitiesService: UtilitiesService,
    private storageStorage: StorageService,
    private store: Store,
    private appTourService: AppTourService,
  ) {
    this.indicatorSubscription = this.indicatorIsComplete$.subscribe(data => {
      if (data) {
        clearInterval(this.tempInterval);
      }
    });
  }

  ngOnInit(): void {
  }

  initIndicator(): void {
    const { hours, minutes, seconds } = this.utilitiesService.secondsToHoursMinutesSeconds(this.secondsStart);
    this.timeLimit = this.timeLimit - this.secondsStart;
    this.timeLimit = this.appTourService.tourMode ? 9999999 : this.timeLimit;
    this.hours = hours;
    this.minutes = minutes;
    this.seconds = seconds;

    if (this.isFinished) {
      if (this.appTourService.tourMode) return;
      this.finished.emit(this.getTime());
      clearInterval(this.tempInterval);
      return;
    }
    this.tempInterval = setInterval(() => {
      if (this.timeLimit <= 0) {
        this.isFinished = true;
        clearInterval(this.tempInterval);
        if (this.appTourService.tourMode) return;
        this.finished.emit(this.getTime());
        return;
      }
      if (this.seconds === 59) {
        this.minutes += 1;
        this.seconds = 0;
      } else if (this.minutes === 59) {
        this.hours += 1;
        this.minutes = 0;
        this.seconds = 0;
      } else {
        this.seconds += 1;
      }
      this.timeLimit -= 1;
      this.storageStorage.setLocalItem('durationAppointment', this.getTime());
    }, 1000);
  }

  ngAfterViewInit(): void {
    this.isFinished = false;
    this.initIndicator();
  }

  onEmitFinishAppointment(): void {
    this.isFinished = true;
    this.finished.emit(this.getTime());
    clearInterval(this.tempInterval);
  }

  getTime(): number {
    return (this.hours * 60 * 60) + (this.minutes * 60) + this.seconds;
  }

  ngOnChanges(changes: SimpleChanges): void {
      if (changes.secondsStart) {
        const { hours, minutes, seconds } = this.utilitiesService.secondsToHoursMinutesSeconds(this.secondsStart);
        this.timeLimit = this.timeLimit - this.secondsStart;
        this.hours = hours;
        this.minutes = minutes;
        this.seconds = seconds;
      }
  }

  async ngOnDestroy(): Promise<void> {
    this.indicatorSubscription.unsubscribe();
  }
}
